import React from "react";
var WizardContext = React.createContext({});
if (process.env.NODE_ENV !== "production") {
    WizardContext.displayName = "WizardContext";
}
export function useWizardContext() {
    return React.useContext(WizardContext);
}
export default WizardContext;
